import commonMediaStyles from "@coworker/apprestructured/src/media-maintenance/styles/common-media-styles.module.css";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import PencilIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/PencilIconPath";
import TrashCanIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import { useTranslation } from "@coworker/locales";

export type ProductCardActionsProps = {
  onDelete?: () => void;
  onEdit?: () => void;
};

export const ProductCardActions = ({
  onDelete,
  onEdit,
}: ProductCardActionsProps) => {
  const { t } = useTranslation();
  return (
    <div className={commonMediaStyles["item-card-action-row"]}>
      {onDelete && (
        <FixaButton
          aria-label={t("deleteString")}
          size="small"
          iconOnly
          ssrIcon={TrashCanIconPath}
          onClick={onDelete}
        />
      )}

      {onEdit && (
        <FixaButton
          aria-label={t("editString")}
          size="small"
          iconOnly
          ssrIcon={PencilIconPath}
          onClick={onEdit}
        />
      )}
    </div>
  );
};
